import { defineStore } from 'pinia'
import dashboardService from '@/modules/reservations/services/dashboard-service'
import { DashboardDTO } from '../models/dashboard'
import { ResponseResult } from '@/core/models/api-responses'

interface DashboardState {
    dashboard:DashboardDTO
    isLoading: boolean
    error: string | null
}

const emptyDashboard: DashboardDTO = {
  numberOfOpenReservations: 0,
  numberOfClosedReservations: 0,
  numberOfCanceledReservations: 0,
  numberOfConfirmedReservations: 0
};

export const useDashboardStore = defineStore('dashboard', { 
    state: (): DashboardState => ({
        dashboard: emptyDashboard,
        isLoading: false,
        error: null
    }),

    getters: {
        getDashboard: (state) => () => {
            return state.dashboard || emptyDashboard
        }
    },

    actions: {
        /**
         * Fetch all vehicles without filters
         */
        async fetchDashboard(): Promise<void> {
            this.isLoading = true
            this.error = null

            try {
                const response: ResponseResult<DashboardDTO> = await dashboardService.getAll()

                if (response.isSuccess && response.data) {
                    this.dashboard = response.data
                } else {
                    this.error = response.error.message || 'Erro ao carregar dashboard'
                    this.dashboard = emptyDashboard
                }
            } catch (error) {
                console.error('Erro ao carregar dashboard', error)
                this.error = 'Erro ao carregar veículos'
                this.dashboard = emptyDashboard
            } finally {
                this.isLoading = false
            }
        },

        /**
         * Clear selected vehicle
         */
        clearDashboard(): void {
            this.dashboard = emptyDashboard
        },

        /**
         * Clear error state
         */
        clearError(): void {
            this.error = null
        },

        /**
         * Reset store state
         */
        resetStore(): void {
            this.dashboard = emptyDashboard
            this.error = null
        }
    }
})